import { render, staticRenderFns } from "./AddBoMItem.vue?vue&type=template&id=00a1f813&"
import script from "./AddBoMItem.vue?vue&type=script&lang=js&"
export * from "./AddBoMItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports